/* eslint-disable max-len */
import { Button, FloatingLabel, Form } from "react-bootstrap";
import { useCallback, useState } from "react";
import PropTypes from "prop-types";

import LwcModal from "../../../components/LwcModal";

const DeleteAccountModal = ({
	handleModalSubmit
}) => {
	const [show, setShow] = useState(false);
	const toggleShow = useCallback(() => setShow((cur) => !cur), []);

	return (
		<>
			<Button onClick={toggleShow} variant="outline-danger">
				Request Account Closure
			</Button>
			<LwcModal
				handleClose={toggleShow}
				handleModalSubmit={handleModalSubmit}
				show={show}
				submitButtonText="Delete Account"
				title="Delete Account"
			>
				<p>
					This will remove all of your identification from our servers and terminate your account. Someone will contact will to proceed with the closure.
				</p>

				<p className="text-danger fw-bold">
					Type DELETE in the box below to confirm.
				</p>

				<FloatingLabel className="mb-3" controlId="deleteAccount" label="Type DELETE">
					<Form.Control
						placeholder="Type DELETE"
						type="text"
					/>
				</FloatingLabel>
			</LwcModal>
		</>
	);
};

DeleteAccountModal.propTypes = {
	handleModalSubmit: PropTypes.func.isRequired
};

export default DeleteAccountModal;
